import React, { useState } from "react";
import EthNft from "../components/nfts/EthNft";
import { Link } from "react-router-dom";

export default function Ethereum() {
    let [collection, setCollection] = useState<string | undefined>();
    let [nfts, setNfts] = useState<any[] | undefined>();

    const loadNfts = async (collection_name: string) => {
        console.log('hi ' + collection_name);
        let collections = await fetch(process.env.REACT_APP_SIMPLEHASH_API_URL + 'nfts/collections?marketplace_collection_id=' + collection_name + '&marketplace_name=opensea', {
            method: 'GET',
            headers: {'Accept': 'application/json', 'X-API-KEY': process.env.REACT_APP_SIMPLEHASH_API_KEY!},
        }).then(response => response.json()).then(x => x.collections);
        if (collections.length === 0) { return; }
        let collection_id = collections[0].id;
        console.log('collection_id: ' + collection_id);

        let resp_nfts : any[] = await fetch(process.env.REACT_APP_SIMPLEHASH_API_URL + 'nfts/collection/' + collection_id, {
            method: 'GET',
            headers: {'Accept': 'application/json', 'X-API-KEY': process.env.REACT_APP_SIMPLEHASH_API_KEY!},
        }).then(response => response.json()).then(x => x.nfts);
        console.log(resp_nfts);
        let nfts_to_show = resp_nfts.filter(nft => nft.last_sale)
            .sort((a, b) => b.last_sale.timestamp.localeCompare(a.last_sale.timestamp))
        ;
        setNfts(nfts_to_show);
    }

    function loadCollection(name: string) {
        setCollection(name);
        loadNfts(name);
    }

    function resetPage() {
        setNfts(undefined);
        setCollection(undefined);
    }

    return (
        <div className='flexColumn justifyStart' style={{minHeight: '300px'}}>
            {collection ?
                nfts ?
                    <div>
                        <div className='subheading'>{collection.toUpperCase()}</div>
                        <table>
                            <tr>
                                <th></th>
                                <th>id</th>
                                <th>sale date</th>
                                <th>amount</th>
                                <th>from</th>
                                <th>to</th>
                            </tr>
                            <tbody>
                            {nfts.map(nft => (
                                <EthNft key={nft.token_id} nft={nft}/>
                            ))}
                            </tbody>
                        </table>
                        <button className='blueButton' onClick={() => resetPage()}>BACK</button>
                    </div>
                    :
                    <div>loading...</div>
                :
                <div className='flexColumn'>
                    <div className='subheading'>Ethereum whales</div>
                    <button className='blueButton' onClick={() => loadCollection('boredapeyachtclub')}>boredapeyachtclub</button>
                    <button className='blueButton' onClick={() => loadCollection('cyberkongz')}>cyberkongz</button>
                    <button className='blueButton' onClick={() => loadCollection('cryptopunks')}>cryptopunks</button>
                    <Link style={{marginTop: '20px'}} to='/'><button className='blueButton'>BACK</button></Link>
                </div>
            }

        </div>
    )
}
